import { render, staticRenderFns } from "./GoTop.vue?vue&type=template&id=0540cfe6&scoped=true"
import script from "./GoTop.vue?vue&type=script&lang=js"
export * from "./GoTop.vue?vue&type=script&lang=js"
import style0 from "./GoTop.vue?vue&type=style&index=0&id=0540cfe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540cfe6",
  null
  
)

export default component.exports